/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2022, Zumper
 */

import { EVENT_NAMES, PAGE_NAMES, PROP_NAMES, track } from '@zcode/mixpanel'
import type { Origin } from '@zcode/nr-utils'
import type { GetState, Listable, MaybeEmptyProperty } from '@zcode/state-type'
import type { Dispatch } from '../../types'
import { getCommonProps } from '../helpers/getCommonProps'

export const mixpanelShortTermClickOut =
  ({
    entity,
    extraPayload,
    origin,
  }: {
    entity: Listable | MaybeEmptyProperty | null | undefined
    extraPayload:
      | { [PROP_NAMES.BUTTON_CLICKED]: string }
      | { [PROP_NAMES.PAGE_NAME]: (typeof PAGE_NAMES)[keyof typeof PAGE_NAMES] }
      | undefined
    origin: 'booknow' | Origin | 'pin'
  }) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState()
    const payload = {
      [PROP_NAMES.PAGE_NAME]: PAGE_NAMES.DETAIL,
      [PROP_NAMES.SECTION]: 'Short Term Click Out',
      ...getCommonProps({ state, entity, origin }),
      ...extraPayload,
    }

    track({ event: EVENT_NAMES.CLICK, payload })
  }
